// Versão do app - gerado automaticamente
export const APP_VERSION = '5.28'
export const BUILD_DATE = '03/05/2026, 04:35'
